module.exports = __webpack_public_path__ + "static/media/md-color-palette.019a16f4.svg";